// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — user-block.classic.js, новая — user-block.cp.js
import { isCp } from 'libs/design';
import * as classic from './user-block.classic';
import * as cp from './user-block.cp';

export const UserBlock = isCp ? cp.UserBlock : classic.UserBlock;
